<template>
  <div>

    <div style="position:fixed;">
      <div style="z-index: 0">
        <v-img
          :src="background"
          :gradient="
            loadingAlimentos || true
              ? backgroundColor
              : ''
          "
          height="100vh"
          style="opacity: 0.9;"
          class="bg-login"
        />
      </div>
    </div>
    <v-container
      fill-height
      fluid
      wrap
      style="padding: 0; margin: 0; position: relative;"
    >

      <v-container
        v-if="loadingAlimentos"
        fluid
        text-xs-center
        fill-height
        align-center
        style="padding:0; margin: 0;"
      >
        <v-layout
          :style="{ height: heightCard, width: widthCard }"
          column
          fill-height
          justify-center
          align-center
        >
          <v-flex
            xs12
            sm12
            md12
            lg6
            xl6>
            <v-progress-circular
              :size="150"
              color="primary"
              indeterminate>
              <span>{{ strings[idioma].aguarde }}</span>
            </v-progress-circular>
          </v-flex>
          <span style="font-weight: 500; padding: 4px">
            {{ strings[idioma].carregando_informacoes }}
          </span>
        </v-layout>
      </v-container>
      <div
        v-if="linkURL === null"
        ref="foo"
        :style="heightOverflow">
        <v-layout
          v-if="!loadingAlimentos"
          style="margin-top: -10px"
          flex
          wrap>
          <v-container
            grid-list-md
            text-xs-center>

            <v-layout
              align-center
              align-content-center
              justify-center
              class="login-text"
            >
              <v-flex
                md4
                xs12
                sm12
                align-center
                align-content-center
                justify-space-between
              >
                <v-layout
                  :column="!($vuetify.breakpoint.width >= 1200)"
                  justify-space-between
                >
                  <v-flex v-if="false">
                    <h2
                      style="color: black; text-align: center; font-size: 13px!important; color: #0D2561;"
                    >
                      {{ user.NOME }}, <br >{{
                        strings[idioma].title_bem_vindo
                      }}
                    </h2>
                  </v-flex>
                  <v-flex>
                    <img
                      :src="logo"
                      transition
                      style="margin:auto; color: black; text-align: center; font-size: 20px!important;"
                      width="130px"
                    >
                  </v-flex>
                </v-layout>
                <v-flex>
                  <template v-if="false && user.pagamentos">
                    <v-card wrap>
                      <template v-for="p in user.pagamentos.filter(p => p.data_pagamento === null && moment().diff(p.data_vencimento, 'days') < 10)">
                        <v-btn :key="p.id" :href="p.link_fatura" target="_blank">Ver fatura</v-btn>
                      </template>
                    </v-card>
                  </template>
                  
                  <template v-if="user.consultor">
                    <div
                      v-show="false"
                      class="tokenizer-container" />
                    <span
                      v-if="user.consultor"
                      style="color: blue; background: #fff; padding: 5px;"
                    >{{ strings[idioma].seu_plano_consultor_e_valido_ate }}
                      {{
                        user.consultoria.data_fim
                          ? moment(user.consultoria.data_fim).format(
                            strings[idioma].formato_datas_sem_hora
                          )
                          : strings[idioma].o_infinito
                      }}</span
                      >
                    <v-btn
                      v-if="user.consultor"
                      :title="strings[idioma].area_do_consultor"
                      href="/consultor">
                      {{ strings[idioma].area_do_consultor }}
                    </v-btn>
                    <SelectCliente
                      v-if="user.consultor"
                      :titulo="strings[idioma].cliente"
                      :$style="'background-color: #fff; padding:10px; padding-top: 20px; width: 330px; border-radius: 10px; font-weight: 900'"/>
                  </template>
                </v-flex>
              </v-flex>
              <v-flex v-if="sessoes && sessoes.length > 0">
                <div class="error pa-2 text-xs-center">
                  <h3 style="color: white;">
                    {{ strings[idioma].foram_encontrados_logins_simultaneos }}:
                  </h3>
                  <ol>
                    <li
                      v-for="s of sessoes"
                      :key="s.id"
                      style="color: white;">
                      <b
                      >({{
                        moment(s.created_at).format(
                          strings[idioma].formato_datas_com_hora
                        )
                      }}(GMT)) -
                        <a
                          :href="'https://www.geodatatool.com/en/?IP=' + s.ip"
                          target="_blank"
                        >{{ s.ip }}</a
                        >
                        - {{ s.os }} - {{ s.browser }} - {{ s.dispositivo }}</b
                        >
                    </li>
                  </ol>
                  <div>
                    <v-btn @click="fuieuLogin()">
                      {{ strings[idioma].fui_eu_estou_de_acordo }}
                    </v-btn>
                    <v-btn @click="naofuieuLogin()">
                      {{ strings[idioma].nao_fui_eu_estou_de_acordo }}
                    </v-btn>
                  </div>
                  <strong>{{
                    strings[idioma].o_compartilhamento_senhas_proibido
                  }}</strong>
                </div>
              </v-flex>
              <v-flex
                v-if="
                  user.empresa_vinculada !== null &&
                    user.empresa_vinculada[0] &&
                    user.empresa_vinculada[0].logo &&
                    user.permissao !== 0 &&
                    !user.premium
                "
                md4
                xs12
                sm12
                align-center
                align-content-center
                justify-center
              >
                <template
                  v-if="
                    user.empresa_vinculada !== null &&
                      user.empresa_vinculada[0] &&
                      user.empresa_vinculada[0].logo &&
                      user.permissao !== 0 &&
                      !user.premium
                  "
                >
                  <v-layout
                    :column="!($vuetify.breakpoint.width >= 1200)"
                    align-center
                    align-content-center
                    justify-space-between
                  >
                    <v-flex>
                      <h2
                        style="color: black; text-align: center; font-size: 13px!important; color: #0D2561;"
                        v-html="strings[idioma].licenciado_para"
                      />
                    </v-flex>
                    <v-flex>
                      <img
                        v-if="
                          user.empresa_vinculada[0].logo &&
                            user.empresa_vinculada[0].logo !== null &&
                            user.empresa_vinculada[0].logo !== 'None'
                        "
                        :src="user.empresa_vinculada[0].logo"
                        transition
                        width="130px"
                      >
                    </v-flex>
                  </v-layout>
                </template>
              </v-flex>

            </v-layout>
            <v-flex
              v-if="
                (!user.consultor || user.consultor === null) &&
                  user.plano &&
                  user.plano !== null &&
                  user.plano.data_inicio &&
                  user.plano.data_final &&
                  moment().diff(user.plano.data_final, 'days') > -10 &&
                  moment().diff(user.plano.data_final, 'days') < 31 &&
                  user.permissao !== 0 &&
                  user.emp_user === null
              "
              style="opacity: 0.7;"
              xs12
            >
              <AvisoPremium />
            </v-flex>
            <v-flex
              v-if="exibeTesteGratis && !getAcessoModulo({ user: user, modulo: SALVAR_DIETA }) && !user.testou_premium && ((user.plano !== null && user.plano.id_empresa === null) || user.plano === null)"
              style="opacity: 0.7;"
              xs12
              @click="testePremium"
            >
              <v-btn>
                {{ strings[idioma].experimente_gratis_7_dias }}
              </v-btn>
            </v-flex>
            <Banner/>
            <v-container
                  grid-list-md
                  text-xs-center
                  style="opacity: 0.8">
                  <v-layout
                    v-if="data"
                    row
                    wrap>
                    <v-flex
                      md3
                      xs12>
                      <v-card
                        color="primary"
                        class="white--text"
                        style="padding: 10px;height: 150px;"
                      >
                        <h2>{{ !possuiDietas ? "-" : data.dietas.count }}</h2>
                        <h4>{{ strings[idioma].formulacoes }}</h4>
                      </v-card>
                    </v-flex>
                    <v-flex
                      md3
                      xs12>
                      <v-card
                        color="black"
                        class="white--text"
                        style="padding: 10px;height: 150px;"
                      >
                        <h2>
                          {{ !possuiPredicoes ? "-" : data.predicoes.count }}
                        </h2>
                        <h4>{{ strings[idioma].predicoes }}</h4>
                      </v-card>
                    </v-flex>
                    <v-flex
                      v-if="
                        data &&
                          data.alimentos &&
                          categorias_alimentos &&
                          categorias_alimentos !== null
                      "
                      md3
                      xs12
                    >
                      <v-card
                        color="orange"
                        class="white--text"
                        style="padding: 10px;height: 150px;"
                      >
                        <h2>
                          {{
                            data.alimentos.empresa.count + data.alimentos.usuario.count  === 0 ? '-' : data.alimentos.empresa.count + data.alimentos.usuario.count
                          }}
                        </h2>
                        <h4>{{ strings[idioma].alimentos_empresa_pessoal }}</h4>
                      </v-card>
                    </v-flex>
                    <v-flex
                      v-if="categorias_alimentos && categorias_alimentos !== null"
                      md3
                      xs12
                    >
                      <v-card
                        color="green"
                        class="white--text"
                        style="padding: 10px;height: 150px;"
                      >
                        <h2>{{ data.alimentos.cqbal.count }}</h2>
                        <h4>{{ strings[idioma].alimentos_cqbal }}</h4>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-container>
          </v-container>

          <template>
            <v-container
              grid-list-md
              align-center
              text-xs-center>
              <v-tabs v-model="tab">
                <v-tab>{{ strings[idioma].dietas_ativas }}</v-tab>
                <v-tab :disabled="!getAcessoModulo({ user: user, modulo: SALVAR_DIETA })">{{ strings[idioma].dietas_predicoes_salvas }}</v-tab>
                <v-tab :disabled="!getAcessoModulo({ user: user, modulo: SALVAR_DIETA })">{{ strings[idioma].comparar_dietas }}</v-tab>
                <v-tab :disabled="!getAcessoModulo({ user: user, modulo: SALVAR_DIETA})">{{ strings[idioma].suplementos_salvos }}</v-tab>
              </v-tabs>
              <template v-if="tab === 2">
                <CompararDietas/>
              </template>
              <template v-if="tab === 0">
                <v-layout
                  v-if="dietasAtivas && dietasAtivas !== null && dietasAtivas.length > 0"
                  row
                  justify-center
                  wrap>
                  <v-flex
                    md6
                    sm12>
                    <v-card>
                      <v-btn
                        color="success"
                        small
                        flat
                        @click="ocultarCard('DIETA_ATIVA', saveCardSettings)">{{ cardCanBeShow('DIETA_ATIVA') ? strings[idioma]['MINIMIZAR']: strings[idioma]['MOSTRAR_DIETAS_ATIVAS'] }}</v-btn>
                      <DietasCard
                        v-if="cardCanBeShow('DIETA_ATIVA')"
                        type="DIETAS_ATIVAS" />
                    </v-card>
                  </v-flex>
                </v-layout>
              </template>
              <template v-if="tab === 1 && getAcessoModulo({ user: user, modulo: SALVAR_DIETA })">
                <v-layout
                  row
                  justify-center
                  wrap>
                  <v-flex
                    v-if="possuiDietas"
                    :lg6="possuiPredicoes"
                    :xl6="possuiPredicoes"
                    :lg12="!possuiPredicoes"
                    :xl12="!possuiPredicoes"
                    :md6="possuiPredicoes"
                    xs12
                  >
                    <v-card>
                      <v-btn
                        color="primary"
                        small
                        flat
                        @click="ocultarCard('DIETA', saveCardSettings)">{{ cardCanBeShow('DIETA') ? strings[idioma]['MINIMIZAR']: strings[idioma]['MOSTRAR_DIETAS_SALVAS'] }}</v-btn>
                      <DietasCard v-if="cardCanBeShow('DIETA')"/>
                    </v-card>
                  </v-flex>
                  <v-flex
                    v-if="possuiPredicoes"
                    :lg6="possuiDietas"
                    :xl6="possuiDietas"
                    :lg12="!possuiDietas"
                    :xl12="!possuiDietas"
                    :md6="possuiDietas"
                    xs12
                  >
                    <v-card>
                      <v-btn
                        color="black"
                        small
                        flat
                        @click="ocultarCard('PREDICAO', saveCardSettings)">{{ cardCanBeShow('PREDICAO') ? strings[idioma]['MINIMIZAR']: strings[idioma]['MOSTRAR_PREDICOES_SALVAS'] }}</v-btn>
                      <PredicoesCard v-if="cardCanBeShow('PREDICAO')" />
                    </v-card>
                  </v-flex>
                </v-layout>
              </template>
              <template v-if="tab === 3 && getAcessoModulo({ user: user, modulo: SALVAR_DIETA })">
                <v-card>
                  <v-card-title>
                    <v-layout wrap>
                      <v-flex xs12 lg10>
                        <h3 style="text-align: left;">{{ strings[idioma].suplementos }}</h3>
                      </v-flex>
                      <v-flex xs12 lg2>
                        <v-btn icon @click="novoSuplemento"> + </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-card-title>
                  <hr />
                  <v-card :style="'max-height: 300px!important; overflow: auto;'">
                    <template v-if="listaSuplementos.length > 0">
                      <v-list
                        two-line
                        dense
                        flat
                        rounded>
                        <template
                          v-for="(alimento, index) in listaSuplementos">
                          <v-list-tile
                            :key="index"
                            flat
                            color="primary"
                            @click="openAlimento(alimento)">
                            <v-list-tile-avatar>
                              <v-icon
                                :class="'text-uppercase'"
                                v-text="'mdi-folder'"
                              />
                            </v-list-tile-avatar>
                            <v-list-tile-content style="min-width: 70%">
                              <v-list-tile-title
                                :class="'text-uppercase'"
                              >
                                {{ alimento.nome }}
                              </v-list-tile-title>
                              <v-list-tile-sub-title>
                                {{ moment(alimento.updated_at.date).format(strings[idioma].formato_datas_com_hora) }}
                              </v-list-tile-sub-title>
                            </v-list-tile-content>

                          </v-list-tile>
                        </template>
                      </v-list>
                    </template>
                    <template v-else>
                      <div><span>{{strings[idioma].sem_resultado}}</span></div>
                    </template>
                  </v-card>
                </v-card>
              </template>
            </v-container>
            <template v-if="tab === 2 && getAcessoModulo({ user: user, modulo: SALVAR_DIETA })">
              <template v-if="categorias_alimentos && getAcessoModulo({ user: user, modulo: GRAFICOS_DASHBOARD })">
                <v-container
                  v-if="data && data.chart && data.chart.tipo"
                  grid-list-md
                  text-xs-center
                >
                  <v-layout
                    row
                    wrap>
                    <v-flex xs12>
                      <v-card flat>
                        <v-btn
                          :color="tabHome === -1 ? 'primary' : ''"
                          style="margin: 20px"
                          @click="getDataWithFilter(-1)"
                        >{{ strings[idioma].tudo }}</v-btn
                        >
                        <v-divider vertical />
                        <v-btn
                          :color="tabHome === 0 ? 'primary' : ''"
                          style="margin: 20px"
                          @click="getDataWithFilter(0)"
                        >{{ strings[idioma].formulacoes }}</v-btn
                        >
                        <v-divider vertical />
                        <v-btn
                          :color="tabHome === 1 ? 'primary' : ''"
                          style="margin: 20px"
                          @click="getDataWithFilter(1)"
                        >{{ strings[idioma].predicoes }}</v-btn
                        >
                      </v-card>
                    </v-flex>
                    <template
                      v-if="dietasAlimentos && dietasAlimentos.length > 1"
                    >
                      <v-flex
                        :md8="dietasGrupoAnimais.length > 1"
                        :xs12="dietasGrupoAnimais.length > 1"
                      >
                        <material-card
                          :text="strings[idioma].alimentos_mais_utilizados"
                          :color="colorCard"
                        >
                          <GChart
                            ref="gchartAlimentos"
                            :data="dietasAlimentos"
                            :options="chartOptions"
                            type="ColumnChart"
                          />
                        </material-card>
                      </v-flex>
                      <v-flex
                        v-if="dietasAnimais.length > 1"
                        :md4="dietasGrupoAnimais.length > 1"
                        xs12
                      >
                        <material-card
                          :text="strings[idioma].tipos_animais"
                          :color="colorCard"
                        >
                          <GChart
                            ref="gchartDietasAnimais"
                            :data="dietasAnimais"
                            :options="chartOptionsLegend"
                            type="PieChart"
                          />
                        </material-card>
                      </v-flex>
                      <template v-if="dietasGrupoAnimais.length > 1">
                        <v-flex
                          md4
                          xs12>
                          <material-card
                            :text="strings[idioma].grupo_genetico"
                            :color="colorCard"
                          >
                            <GChart
                              ref="gchartGrupoAnimais"
                              :data="dietasGrupoAnimais"
                              :options="chartOptions"
                              type="ColumnChart"
                            />
                          </material-card>
                        </v-flex>
                        <v-flex
                          md4
                          xs12>
                          <material-card
                            :text="strings[idioma].regime"
                            :color="colorCard"
                          >
                            <GChart
                              ref="gchartRegimeAnimais"
                              :data="dietasRegimeAnimais"
                              :options="chartOptions"
                              type="ColumnChart"
                            />
                          </material-card>
                        </v-flex>
                        <v-flex
                          md4
                          xs12>
                          <material-card
                            :text="strings[idioma].sexo"
                            :color="colorCard"
                          >
                            <GChart
                              ref="gchartSexoAnimais"
                              :data="dietasSexoAnimais"
                              :options="chartOptions"
                              type="ColumnChart"
                            />
                          </material-card>
                        </v-flex>
                      </template>
                    </template>
                  </v-layout>
                </v-container>
                <v-container
                  grid-list-md
                  text-xs-center>
                  <v-layout
                    row
                    wrap>
                    <template v-if="dietasEstadoFisiologicoAnimais.length > 1">
                      <template>
                        <v-flex
                          md12
                          xs12>
                          <material-card
                            :text="
                              strings[idioma].vaca +
                                ' >> ' +
                                strings[idioma].estado_fisiologico
                            "
                            :color="colorCard"
                          >
                            <GChart
                              ref="gchartEstadoFisiologico"
                              :data="dietasEstadoFisiologicoAnimais"
                              :options="chartOptions"
                              type="ColumnChart"
                            />
                          </material-card>
                        </v-flex>
                      </template>
                    </template>
                  </v-layout>
                </v-container>
              </template>
            </template>
          </template>
          <v-container
            v-if="!acesso_premium || !(possuiDietas || possuiPredicoes)"
            grid-list-md
          >
            <v-layout
              row
              wrap>
              <v-flex>
                <div v-if="!acesso_premium">
                  <iframe
                    :height="$vuetify.breakpoint.mdAndUp ? '7300px' : '13000px'"
                    :style="'border: 0px; width: ' + widthIFRAME + ';'"
                    :src="temSejaPremiumParceiro ? empresaParceiraInfo.seja_premium_link : 'https://brcorte.com.br/site/seja-premium.php?tipo=' + user.perfil + '&lang=' + (idioma === 0 ? 'pt' : 'en')"
                    data-origwidth=""
                    data-origheight="5300px"
                  />
                  <v-card
                    text=""
                    xs4
                    style="margin: 0px;" />
                </div>
                <material-card
                  text=""
                  xs4>
                  <Apresentacao  v-if="$store.state.app.exibeConteudoApresentacao" style="text-align: justify;" />
                </material-card>
              </v-flex>
            </v-layout>
          </v-container>
          <PostsWP v-if="$store.state.app.exibeBlog" />
          <PendenciasUser />
        </v-layout>
      </div>
      <div v-else>
        <iframe
          :src="linkURL"
          style="border: none;
    position: fixed;
    margin-top: 50px;
    top: 50%;
    left: 50%;
    min-width: 100%;
    min-height: 100%;
    width: auto;
    height: auto;
    -webkit-transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%) translateY(-50%);
    background-size: cover"
        />
      </div>
    </v-container>
  </div>
</template>
<style scoped>
.login-text div {
  -webkit-filter: blur(0px);
  -moz-filter: blur(0px);
  -o-filter: blur(0px);
  -ms-filter: blur(13px);
  filter: blur(0px);

  -webkit-backdrop-filter: blur(2px); /* Safari 9+ */
  backdrop-filter: blur(2px); /* Chrome and Opera */

  overflow: auto;
}





</style>
<script>
import { mapState } from 'vuex'
import Apresentacao from './statics/instrucoes/Apresentacao'
import DietasCard from './components/DietasCard'
import PostsWP from './components/PostsWP'
import PredicoesCard from './components/PredicoesCard'
import AvisoPremium from './components/AvisoPremium'
import PendenciasUser from './components/PendenciasUser'
import Premium from './Premium'
import { getData, updateData, getAlimentos, transposeTable, createMD5 } from '@/utils/utils'
import { SALVAR_DIETA, GRAFICOS_DASHBOARD } from '@/utils/types'
import moment from 'moment'
import { replaceSpecialChars } from '@/utils/vuex'
import SelectCliente from './consultor/components/SelectCliente.vue'
import Cupons from './components/Cupons'
import Banner from './components/Banner.vue'
import CompararDietas from './components/CompararDietas'
import { set } from '../utils/vuex'
export default {
  components: {
    Apresentacao,
    DietasCard,
    PredicoesCard,
    AvisoPremium,
    Premium,
    PostsWP,
    PendenciasUser,
    SelectCliente,
    Cupons,
    Banner,
    CompararDietas
  },
  data () {
    return {
      tab: 0,
      linkURL: null,
      loadingAlimentos: false,
      searchDieta: null,
      searchPredicao: null,
      searchTabela: null,
      // logo: process.env.VUE_APP_LOGO_AZUL ? process.env.VUE_APP_LOGO_AZUL : 'img/brcorte-logo.png',
      logo: process.env.VUE_APP_LOGO_BRANCA ? process.env.VUE_APP_LOGO_BRANCA : 'img/brcorte5-logobranca.png',
      background: 'img/background-login.jpg',
      backgroundColor: process.env.VUE_APP_BG ? process.env.VUE_APP_BG : 'to top right, rgba(100,115,201,.2), rgba(25,32,72,.7)',
      tipoTab: -1,
      sessoes: [],
      empresaParceiraInfo: null,
      SALVAR_DIETA: SALVAR_DIETA,
      GRAFICOS_DASHBOARD: GRAFICOS_DASHBOARD,
      cards: {
        DIETA_ATIVA: true,
        DIETA: true,
        PREDICAO: true
      }
    }
  },
  computed: {
    ...mapState('app', [
      'dietasAtivas',
      'data',
      'acesso_premium',
      'strings',
      'idioma',
      'user',
      'ingredientes',
      'optionsNumber',
      'alimentos_selecionados',
      'categorias_alimentos',
      'alimentos_usuario',
      'alert',
      'dietas',
      'predicoes',
      'tabelas',
      'empresa',
      'tabHome',
      'exibeTesteGratis'
    ]),
    binding () {
      const binding = {}
      if (this.$vuetify.breakpoint.mdAndUp) binding.row = true
      else binding.row = false
      return binding
    },
    colorCard () {
      return 'indigo lighten-5'
    },
    listaSuplementos () {
      let data = this.data
      return (data.alimentos.usuario && data.alimentos.usuario.count >= 1) ? Object.values(data.alimentos.usuario)[1].filter(a => a.ingredientes && a.EXCLUIDO === 0) : []

    },
    temSejaPremiumParceiro () {
      return !!(this.empresaParceiraInfo && this.empresaParceiraInfo.seja_premium_link)
    },
    predicoesSalvas () {
      return this.predicoes !== null
        ? this.predicoes.filter((p) => p.user_id === this.user.id)
        : []
    },
    possuiPredicoes () {
      return (
        this.predicoes &&
        this.predicoes.length >= 0 &&
        this.predicoesSalvas.length > 0
      )
    },
    dietasSalvas () {
      return this.dietas !== null
        ? this.dietas.filter((p) => p.user_id === this.user.id)
        : []
    },
    possuiDietas () {
      return (
        this.dietas && this.dietas.length >= 0 && this.dietasSalvas.length > 0
      )
    },
    chartOptions () {
      return {
        legend: {
          position: 'none'
        },
        chart: {
          legend: {
            position: 'none'
          }
        },
        colors: ['indigo', '#e6693e', '#ec8f6e', '#f3b49f', '#f6c7b6'],
        height: 250
      }
    },
    chartOptionsLegend () {
      return {
        legend: {
          position: 'bottom'
        },
        chart: {
          legend: {
            position: 'bottom'
          }
        },
        colors: ['blue', 'orange', '#e0440e', '#00FA9A', '#f3b49f', '#f6c7b6'],
        height: 250
      }
    },

    filter () {
      return (item, search, textKey) =>
        item[textKey].toLowerCase().search(search.toLowerCase()) > -1
    },
    heightCard () {
      return String(this.$vuetify.breakpoint.height - 80) + 'px'
    },
    widthCard () {
      return String(this.$vuetify.breakpoint.width - 300) + 'px'
    },
    widthIFRAME () {
      return this.$vuetify.breakpoint.mdAndUp
        ? String(this.$vuetify.breakpoint.width - 320) + 'px'
        : String(this.$vuetify.breakpoint.width) + 'px'
    },
    heightDialog () {
      return this.$vuetify.breakpoint.xs
        ? String(this.$vuetify.breakpoint.height - 150) + 'px'
        : String(this.$vuetify.breakpoint.height - 240) + 'px'
    },
    heightOverflow () {
      return (
        'max-height: ' +
        String(this.$vuetify.breakpoint.height - 50) +
        'px; overflow: auto;'
      )
    },
    heightTree () {
      return (
        'max-height: ' +
        String(this.$vuetify.breakpoint.height - 200) +
        'px; overflow: auto; min-height: 200px;'
      )
    },
    dietasFilter () {
      if (this.dietas === null) return this.dietas
      if (this.searchDieta === null || this.searchDieta.trim() === '') {
        return this.dietas.filter(
          (u) =>
            u.animal &&
            u.animal.tipo &&
            u.animal.tipo !== '' && u.animal.tipo !== null
        )
      }
      return this.dietas.filter(
        (u) =>
          new RegExp(
            replaceSpecialChars(this.searchDieta.toLowerCase()),
            'i'
          ).test(u.nome ? u.nome : u.name) &&
          u.animal &&
          u.animal.tipo &&
          u.animal.tipo !== '' && u.animal.tipo !== null
      )
    },
    dietasGrupoAnimais () {
      let dados = [['Animal', 'Quantidade']]
      if (this.data && this.data.chart) {
        let data = this.data.chart.grupo
        let ordem = ['zebuino', 'cruzado_corte', 'cruzado_leite']
        for (let a of ordem) {
          if (!data[a]) continue
          dados.push([this.strings[this.idioma][a], data[a]])
        }
      }

      return dados
    },
    dietasRegimeAnimais () {
      let dados = [['Animal', 'Quantidade']]
      if (this.data && this.data.chart) {
        let data = this.data.chart.regime
        let ordem = ['confinamento', 'pasto']
        for (let a of ordem) {
          if (data[a] === undefined) continue
          dados.push([this.strings[this.idioma][a], data[a]])
        }
      }
      return dados
    },
    dietasSexoAnimais () {
      let dados = [['Animal', 'Quantidade']]

      if (this.data && this.data.chart) {
        let data = this.data.chart.sexo
        let ordem = ['macho', 'macho_castrado', 'femea']
        for (let a of ordem) {
          if (data[a] === undefined) continue
          dados.push([this.strings[this.idioma][a], data[a]])
        }
      }
      return dados
    },
    dietasEstadoFisiologicoAnimais () {
      let dados = [['Animal', 'Quantidade']]
      if (this.data && this.data.chart) {
        let data = this.data.chart.estado_fisiologico
        let ordem = [
          'nao_gestante',
          'lactante',
          'gestante',
          'gestante_lactante'
        ]
        for (let a of ordem) {
          if (data[a] === undefined) continue
          dados.push([this.strings[this.idioma][a], data[a]])
        }
      }

      return dados
    },
    dietasAlimentos () {
      const alimentosSt = JSON.parse(localStorage.getItem('alimentosStored'))
      let dados = [['Animal', 'Quantidade']]
      if (!alimentosSt) return
      if (this.data && this.data.chart) {
        let data = this.data.chart.alimentos
        let d = []
        for (let a in data) {
          if (!alimentosSt[a]) continue
          d.push({ id: a, valor: data[a] })
        }
        d = d.sort((a, b) =>
          a.valor > b.valor ? -1 : a.valor < b.valor ? 1 : 0
        )
        for (let a of d.splice(0, 15)) {
          if (!alimentosSt[a.id]) continue
          dados.push([
            alimentosSt[a.id][(this.idioma === 0 ? 'name' : (this.idioma === 1 ? 'name_en' : 'name_es'))],
            data[a.id]
          ])
        }
      }
      return dados
    },
    dietasAnimais () {
      let dados = [['Animal', 'Quantidade']]
      if (this.data && this.data.chart) {
        let data = this.data.chart.tipo
        let ordem = ['crescimento_terminacao', 'vaca', 'bezerro']
        for (let a of ordem) {
          if (!data[a]) continue
          dados.push([this.strings[this.idioma][a], data[a]])
        }
      }
      return dados
    },
    predicoesFilter () {
      if (this.searchPredicao === null || this.searchPredicao.trim() === '') { return this.predicoes }
      return this.predicoes.filter((u) =>
        new RegExp(
          replaceSpecialChars(this.searchPredicao.toLowerCase()),
          'i'
        ).test(u.nome ? u.nome : u.name)
      )
    },
    tabelasFilter () {
      if (this.searchTabela === null || this.searchTabela.trim() === '') { return this.tabelas }
      return this.tabelas.filter((u) =>
        new RegExp(
          replaceSpecialChars(this.searchTabela.toLowerCase()),
          'i'
        ).test(u.nome ? u.nome : u.name)
      )
    }
  },
  watch: {
    tipoTab (val, old) {
      this.$store.state.app.tabHome = val
    }
  },
  mounted () {
    this.getCardSettings((card) => {
      this.cards = card
    })
    if (this.user.plano && this.user.plano.id_empresa !== null) {
      this.getInfoEmpresa(this.user.plano.id_empresa)
    }
    this.$store.dispatch('getDietasAtivas')
    let backgrounds = [
      'img/background-bois.jpg',
      'img/gado-background.jpg',
      'img/background-login.jpg',
      'img/Ocasião_da_SH_e_Batuque_do_R.I..jpg',
      'img/IMG-20180329-WA0001.jpg',
      'img/IMG-20180330-WA0012.jpg',
      'img/IMG-20181118-WA0008.jpg'
    ]
    this.background =
      backgrounds[parseInt(Math.random() * 100) % backgrounds.length]
    this.queryWork()
    this.getData()
    if (!this.categorias_alimentos) {
      this.loadAlimentosDieta()
    }
    setTimeout(() => {
      let lastPage = sessionStorage.getItem('lastPage')
      const aprov = sessionStorage.getItem('dependeAprovacao')
      if (
        lastPage &&
        (aprov === null || (aprov && aprov === false)) &&
        localStorage.getItem('user')
      ) {
        sessionStorage.removeItem('lastPage')
        window.location.href = lastPage
      }
      this.getSessoes()
    }, 1000)
    if (this.getAcessoModulo({ user: this.user, modulo: SALVAR_DIETA })) {
      this.tab = 1
    }
  },
  methods: {
    novoSuplemento() {
      window.location.href='/formulacao-suplemento'
    },
    cardCanBeShow (tipo) {
      return this.cards[tipo]
    },
    getCardSettings (handle = null) {
      let conf = localStorage.getItem('cardSettings')
      let ret = null
      if (!conf) ret = this.cards
      else ret = JSON.parse(conf)
      if (handle !== null) handle(ret)
      return ret
    },
    saveCardSettings () {
      localStorage.setItem('cardSettings', JSON.stringify(this.cards))
    },
    ocultarCard (tipo, handle = null) {
      this.cards[tipo] = !this.cards[tipo]
      if (handle !== null) handle(this.card)
      return this.cards[tipo]
    },
    fuieuLogin () {
      this.sessoes = []
      localStorage.setItem('sessoes', JSON.stringify(this.sessoes))
    },
    mudarSenha () {
      this.loadingAlimentos = true
      this.axios
        .post('/auth/esqueciSenha', { email: this.user.email })
        .then((response) => {
          this.loadingAlimentos = false
          let msg = this.strings[this.idioma].enviado.format(this.user.email)
          let title = this.strings[this.idioma].mudanca_senha
          this.$store.commit('openOKModal', { title, msg })
        })
        .catch((reason) => {
          this.loadingAlimentos = false
          let msg = this.strings[this.idioma].usuario_nao_encontrado
          let time = 6000
          this.$store.commit('openErrorAlert', { msg, time })
        })
    },
    naofuieuLogin () {
      this.sessoes = []
      localStorage.setItem('sessoes', JSON.stringify(this.sessoes))
      this.mudarSenha()
    },
    getSessoes () {
      this.axios.post('auth/meuIP', {}).then((r) => {
        let meuIP = r.data.data
        this.sessoes = JSON.parse(localStorage.getItem('sessoes'))
        if (this.sessoes && this.sessoes !== null) {
          this.sessoes = this.sessoes.filter((s) => s.ip !== meuIP)
        }
      })
    },
    testePremium () {
      let isPendente = localStorage.getItem('pendente')
      if (isPendente) {
        this.alertAtualizeOsDados()
        return
      }

      if (
        !confirm(this.strings[this.idioma].voce_realmente_quer_ativar_premium)
      ) { return }
      this.axios.post('user/testarPremium').then((r) => {
        setTimeout(() => {
          window.location.href = '/'
        }, 1000)
        this.sweetAlert(
          this.strings[this.idioma].experimente_gratis_7_dias_confirmar
        )
      })
    },
    sortByKey (jsObj) {
      var sortedArray = []

      // Push each JSON Object entry in array by [key, value]
      for (var i in jsObj) {
        sortedArray.push([i, jsObj[i]])
      }

      // Run native sort function and returns sorted array.
      return sortedArray.sort()
    },
    salvarGrafico (ref) {
      const chart = this.$refs[ref].chartObject
      var imgUri = chart.getImageURI()
      var url = imgUri.replace(
        /^data:image\/[^;]+/,
        'data:application/octet-stream'
      )
      let link = document.createElement('a')
      link.href = url
      link.download = 'graph' + new Date().getTime() + '.png'
      link.target = '_blank'
      link.click()
    },
    queryWork () {
      if (this.$route.query.link) {
        sessionStorage.setItem('link', this.$route.query.link)
        window.location.href = '/iframe'
      } else if (sessionStorage.getItem('link')) {
        let linkURL = sessionStorage.getItem('link')
        sessionStorage.removeItem('link')
        this.linkURL = linkURL
      }
    },
    loadAlimentosDieta () {
      this.loadingAlimentos = true
      this.loadingStep1 = true

      getAlimentos(this.$store, this.axios).then((r) => {
        this.loadingAlimentos = false
        this.loadingStep1 = false
      })
    },
    moment (...args) {
      return moment(...args)
    },
    getData () {
      return getData(this.$store.state, this.axios).then((r) => {
        this.tipoTab = -1
      })
    },
    getDataWithFilter (tipo_dieta = null) {
      this.tipoTab = 5
      if (tipo_dieta === null || tipo_dieta === -1) return this.getData()
      let cliente = JSON.parse(localStorage.getItem('cliente'))
      let param = { tipoDieta: tipo_dieta }
      if (cliente && cliente !== null) param['id_cliente'] = cliente.id
      return this.axios.post('data/chart', param).then((response) => {
        let data = response.data.data
        setTimeout(() => {
          this.$store.state.app.data = Object.assign(
            {},
            this.$store.state.app.data
          )
          this.$store.state.app.data.chart = data
          this.data.chart = data
          this.tipoTab = tipo_dieta
        }, 200)
      })
    },
    updateData () {
      return updateData(this.$store.state, this.axios)
    },
    openAlimento (al) {
      let alimento = Object.assign({}, al)
      alimento.nome_sci = alimento.nome_cientifico
      alimento.tipo = alimento.id_tipo
      let win = window.open('/formulacao-suplemento?alid='+ alimento.id + '&assinatura=' + createMD5(String(alimento.id)), '_blank')
      if (!win) window.location.href = '/formulacao-suplemento?alid='+ alimento.id + '&assinatura=' + createMD5(String(alimento.id))
    },
    openDieta (dieta) {
      this.$store.commit('loadDieta', dieta.nome)
      setTimeout(() => {
        this.$router.push(
          '/formulacao-dieta?dieta=' + btoa(JSON.stringify(dieta))
        )
      }, 300)
    },
    openPredicao (dieta) {
      this.$store.commit('loadPredicao', dieta.nome)
      setTimeout(() => {
        this.$router.push(
          '/predicao-desempenho?predicao=' + btoa(JSON.stringify(dieta))
        )
      }, 300)
    },
    openTabela (dieta) {
      this.$store.commit('loadTabela', dieta.name)
      setTimeout(() => {
        this.$router.push(
          '/tabela-resumida?tabela=' + btoa(JSON.stringify(dieta))
        )
      }, 300)
    },
    removeDieta (dieta) {
      delete this.remove
      if (confirm(this.strings[this.idioma].msg_remove)) {
        this.$store
          .dispatch('removeDieta', dieta)
          .catch((_) => alert('Problema ao remover dieta!!!'))
          .then((_) => {
            if (this.tipoTab && this.tipoTab > -1) { this.getDataWithFilter(this.tipoTab) } else this.getData()
            this.updateData()
          })
      }
    },
    removePredicao (dieta) {
      delete this.remove
      if (confirm(this.strings[this.idioma].msg_remove)) {
        this.tipoTab = 5
        this.$store
          .dispatch('removePredicao', dieta)
          .catch((_) => console.log('Problema ao remover a dieta!!!'))
          .then((_) => {
            this.getDataWithFilter(-1)
            this.updateData()
            this.tipoTab = -1
          })
      }
    },
    removeTabela (dieta) {
      delete this.remove
      if (confirm(this.strings[this.idioma].msg_remove)) {
        this.$store.commit('removeTabela', dieta)
        this.updateData()
      }
    },
    async getInfoEmpresa (idEmpresa) {
      try {
        let res = await this.$getInfoEmpresa(idEmpresa)
        this.empresaParceiraInfo = res
      } catch (error) {
        this.empresaParceiraInfo = null
        console.log(error)
      }
    }
  }
}
</script>
